import { makeAutoObservable } from "mobx";
import { TextFieldControler, ErrorBox } from "../../form";
import { toPairs } from "../../core";
import { UserNote } from "../../ordering/UserNote/UserNote";
export class QrWaiterFulfillmentFormControler {
    constructor(params) {
        var _a, _b;
        this.type = "QrWaiter";
        this.userNoteMaxLength = UserNote.MAX_LENGTH;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.userNoteController = new TextFieldControler({
            initialValue: (_b = (_a = this.fulfillmentInstructions.userNote) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "",
            update: (value) => {
                this.fulfillmentInstructions.userNote = new UserNote({ value });
            },
            errorBox: new ErrorBox({
                domainObjects: [this.fulfillmentInstructions],
                // TODO: translation
                errorMessages: {
                    MaxLengthExceeded: `Max length of ${this.userNoteMaxLength} exceeded.`,
                },
            }),
        });
        makeAutoObservable(this);
    }
    touch() {
        toPairs(this.fields).forEach(([_, field]) => {
            if ("onBlur" in field)
                field.onBlur();
        });
    }
    get fields() {
        return {
            userNote: this.userNoteController,
        };
    }
}
